<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'MatchDetailDataProvider',
  props: {
    matchId: { type: String, required: true }
  },
  created() {
    this.load(this.matchId);
  },
  watch: {
    matchId(newId, oldId) {
      if (newId && newId !== oldId) {
        this.load(newId);
      }
    }
  },
  beforeDestroy() {
    this.clearDetail();
  },
  methods: {
    ...mapActions('MatchDetail', ['load']),
    clearDetail() {
      this.$store.commit('MatchDetail/clear');
    }
  },
  computed: {
    ...mapGetters('MatchDetail', ['getMatch', 'isLoading', 'failed'])
  },
  render() {
    return this.$scopedSlots.default({
      match: this.getMatch,
      loading: this.isLoading,
      failed: this.failed
    });
  }
};
</script>
